import { type FormEvent, type ReactNode, useEffect, useState } from 'react';

const SESSION_KEY = 'checkio_demo_password';
const SALES_EMAIL_HREF = 'mailto:francisco@isveritas.ai';

export default function PasswordGate({ children }: { children: ReactNode }) {
  const demoPassword = import.meta.env.VITE_DEMO_PASSWORD;
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!demoPassword) {
      setIsUnlocked(true);
      return;
    }

    if (sessionStorage.getItem(SESSION_KEY) === demoPassword) {
      setIsUnlocked(true);
    }
  }, [demoPassword]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (value === demoPassword) {
      sessionStorage.setItem(SESSION_KEY, value);
      setError('');
      setIsUnlocked(true);
      return;
    }

    setError('Incorrect password.');
  };

  if (isUnlocked) {
    return <>{children}</>;
  }

  return (
    <div className="password-gate-shell min-h-screen bg-veritas-gray-50 text-veritas-navy">
      <div className="fixed inset-0 bg-veritas-navy/30" />
      <div className="relative flex min-h-screen items-center justify-center px-4">
        <form
          onSubmit={handleSubmit}
          className="password-gate w-full max-w-sm rounded-2xl border border-veritas-navy/10 bg-white p-6 shadow-veritas-soft"
        >
          <img src="/brand/veritas-primary.svg" alt="Veritas" className="mb-6 h-10 w-auto" />
          <h1 className="mb-2 text-2xl font-semibold">Demo access</h1>
          <p className="mb-5 text-sm text-veritas-gray-500">
            Enter the demo password to unlock the live UI.
          </p>
          <label className="mb-2 block text-sm font-medium" htmlFor="demo-password">
            Password
          </label>
          <input
            id="demo-password"
            type="password"
            value={value}
            onChange={(event) => {
              setValue(event.target.value);
              if (error) {
                setError('');
              }
            }}
            className="w-full rounded-xl border border-veritas-navy/15 px-4 py-3 outline-none transition focus:border-veritas-navy"
            autoComplete="current-password"
          />
          {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
          <button
            type="submit"
            className="mt-5 w-full rounded-xl bg-veritas-navy px-4 py-3 text-sm font-semibold text-white transition hover:bg-veritas-navy/90"
          >
            Unlock demo
          </button>
          <a
            href={SALES_EMAIL_HREF}
            className="mt-3 flex w-full items-center justify-center rounded-xl border border-veritas-navy/20 px-4 py-3 text-sm font-semibold text-veritas-navy transition hover:bg-veritas-gray-50"
          >
            Contact Sales
          </a>
        </form>
      </div>
    </div>
  );
}
